import { render, staticRenderFns } from "./DocTable.vue?vue&type=template&id=281aee26&scoped=true&"
import script from "./DocTable.vue?vue&type=script&lang=js&"
export * from "./DocTable.vue?vue&type=script&lang=js&"
import style0 from "./DocTable.vue?vue&type=style&index=0&id=281aee26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281aee26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
